import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { findDOMNode } from "react-dom";
import { Event } from "./lib/utils"; //拖拽的尺表线

var DragResizerLine = /*#__PURE__*/function (_Component) {
  _inherits(DragResizerLine, _Component);

  var _super = _createSuper(DragResizerLine);

  function DragResizerLine(props) {
    var _this;

    _classCallCheck(this, DragResizerLine);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleResizerMove", function (event) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          left = _this$props.left,
          dataSource = _this$props.dataSource,
          onChange = _this$props.onChange,
          defaultWidth = _this$props.defaultWidth,
          minWidth = _this$props.minWidth;
      var _this$state = _this.state,
          x = _this$state.x,
          moveX = _this$state.moveX; // console.log(`AAA---resizer--line--move`,event)

      if (visible) {
        var newmoveX = moveX + (event.clientX - x); //计算出移动的距离，向左移动则值小于0，右右移动则值大于0
        // console.log(`AAA---resizer--line--移动距离：${newmoveX}`)

        if (defaultWidth + newmoveX < minWidth) {
          newmoveX = minWidth - defaultWidth;
        }

        _this.setState({
          left: left + newmoveX,
          x: event.clientX,
          moveX: newmoveX
        });

        onChange && onChange(event, moveX, dataSource);
        Event.stopPropagation(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResizerDown", function (event) {
      // console.log(`AAA---resizer--line--down`,event)
      var visible = _this.props.visible;

      if (visible) {
        // console.log(`AAA---resizer--line--down-finish`,event)
        _this.setState({
          moveX: 0,
          x: event.clientX
        });

        Event.stopPropagation(event);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResizerUp", function (event) {
      var _this$props2 = _this.props,
          visible = _this$props2.visible,
          dataSource = _this$props2.dataSource,
          onResizeEnd = _this$props2.onResizeEnd;
      var moveX = _this.state.moveX;

      if (visible) {
        // console.log(`AAA---resizer--line--up`,event)
        onResizeEnd && onResizeEnd(event, moveX, dataSource);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResizerCancel", function (event) {
      var _this$props3 = _this.props,
          visible = _this$props3.visible,
          dataSource = _this$props3.dataSource,
          onResizeCancel = _this$props3.onResizeCancel;

      if (visible) {
        onResizeCancel && onResizeCancel(event, 0, dataSource);
      }
    });

    _this.state = {
      left: props.left // width: props.width||0

    };
    return _this;
  }

  _createClass(DragResizerLine, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.initEvent(this.props.container);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeEvent(this.props.container);
    } //初始化事件

  }, {
    key: "initEvent",
    value: function initEvent(container) {
      // console.log("AAA---Line--->initEvent",container);
      if (container) {
        var domElem = findDOMNode(container);
        Event.addHandler(domElem, 'mousedown', this.handleResizerDown);
        Event.addHandler(domElem, 'mousemove', this.handleResizerMove);
        Event.addHandler(domElem, 'mouseup', this.handleResizerUp);

        if (domElem !== document.body) {
          Event.addHandler(document.body, 'mouseup', this.handleResizerCancel);
        }
      }
    } //移除事件

  }, {
    key: "removeEvent",
    value: function removeEvent(container) {
      // console.log("AAA---Line--->removeEvent",container);
      if (container) {
        var domElem = findDOMNode(container);
        Event.removeHandler(domElem, 'mousedown', this.handleResizerDown);
        Event.removeHandler(domElem, 'mousemove', this.handleResizerMove);
        Event.removeHandler(domElem, 'mouseup', this.handleResizerUp);

        if (domElem !== document.body) {
          Event.removeHandler(document.body, 'mouseup', this.handleResizerCancel);
        }
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if ('left' in nextProps) {
        this.setState({
          left: nextProps.left
        });
      }
    }
  }, {
    key: "start",
    value: function start(event) {
      this.setState({
        moveX: 0,
        x: event.clientX
      });
      Event.stopPropagation(event);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          clsPrefix = _this$props4.clsPrefix,
          height = _this$props4.height,
          visible = _this$props4.visible;
      var left = this.state.left;
      var style = {
        left: left,
        height: height,
        display: visible ? 'block' : 'none'
      }; // console.log(`AAA---resizer--line:left${style.left}`)

      return /*#__PURE__*/React.createElement("div", {
        style: style,
        className: "".concat(clsPrefix, "-drag-resizer")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-drag-resizer-line")
      }));
    }
  }]);

  return DragResizerLine;
}(Component);

_defineProperty(DragResizerLine, "defaultProps", {
  clsPrefix: '',
  //样式名前缀
  container: null,
  //所属容器
  onResizeEnd: null,
  //当释放resizer时出发，接收参数当前的宽度
  onResizeCancel: null,
  //当释放resizer时在容器以外区域则触发取消回调
  onChange: null,
  //当移动resizer时出发，接收参数相对位移
  visible: false,
  //是否可见
  left: null,
  //左侧距离
  height: null,
  //高度
  defaultWidth: null,
  //当前矩阵宽度
  minWidth: null,
  //最小宽度
  // maxWidth:null,//最大宽度
  dataSource: null //当前对象信息

});

export default DragResizerLine;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-table/src/DragResizerLine.js